import { render, staticRenderFns } from "./SupplierSalesRank.vue?vue&type=template&id=651e4bb7&scoped=true&"
import script from "./SupplierSalesRank.vue?vue&type=script&lang=js&"
export * from "./SupplierSalesRank.vue?vue&type=script&lang=js&"
import style0 from "./SupplierSalesRank.vue?vue&type=style&index=0&id=651e4bb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651e4bb7",
  null
  
)

export default component.exports